import { render } from "./Room.vue?vue&type=template&id=f0386d88&ts=true"
import script from "./Room.vue?vue&type=script&lang=ts"
export * from "./Room.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__